/**
 * The privacy policy URL registered on the Google OAuth consent screen.
 *
 * Absolute, and pointing at the apex, because Google's verification requires the privacy
 * link on the app's homepage to match the URL configured in the Cloud Console exactly.
 * That registered URL is the apex one and is already brand-verified, so repointing the
 * console at the app subdomain instead would put the whole app back through review.
 *
 * The app bundle still serves the same policy at /privacy: it is the same PrivacyPage
 * component the apex renders (see catalog/CatalogApp.tsx), only wearing Scheda's mark
 * rather than Delgentic's. The route stays for anyone holding an old bookmark, but
 * nothing links to it, so a reviewer following the site never lands on the copy.
 */
export const PRIVACY_POLICY_URL = "https://delgentic.com/privacy";

/**
 * The terms of service URL for the Google OAuth consent screen's "Terms of Service"
 * field, absolute and on the apex for exactly the reason above: the reviewer checks
 * that the link on the homepage is the one registered in the console.
 *
 * Register this alongside the privacy URL in the SAME consent-screen submission.
 * Each edit to that screen restarts the video review, so batching them costs one
 * review instead of two.
 */
export const TERMS_OF_SERVICE_URL = "https://delgentic.com/terms";
